import { Component, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { DewAuthService } from 'src/authentication/core/auth.service';
import { Config } from '../config';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
})
export class NavigationComponent {

    @Output() closeSideNav = new EventEmitter<any>();

    sideNavTrigger(event) {
        this.closeSideNav.emit(event);
    }

    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void

    constructor(public authService: DewAuthService,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher) {
        this.mobileQuery = media.matchMedia('(max-width: 960px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    project = { name: Config.projectName, logo: Config.projectLogoUrl, navigationType: Config.navigationType };
    ngOnInit() {
    }
    onLogout() {
        this.authService.logout();
    }
    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }
}
